import * as React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { subscribeToNotices } from "@/taskpane/utility/notice";

const AUTO_DISMISS_MS = 6000;

export default function NoticeBar() {
  const [message, setMessage] = React.useState("");

  React.useEffect(() => subscribeToNotices(setMessage), []);

  React.useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => setMessage(""), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [message]);

  if (!message) return null;

  return (
    <MessageBar messageBarType={MessageBarType.warning} onDismiss={() => setMessage("")} role="alert">
      {message}
    </MessageBar>
  );
}
